import { render, staticRenderFns } from "./wxplayer.vue?vue&type=template&id=135a5fc6&scoped=true&"
import script from "./wxplayer.vue?vue&type=script&lang=js&"
export * from "./wxplayer.vue?vue&type=script&lang=js&"
import style0 from "./wxplayer.vue?vue&type=style&index=0&id=135a5fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135a5fc6",
  null
  
)

export default component.exports